export const fieldsAddressCertificate = {};
export const fieldsAddressDocCertificate = {
  addressCaption: {
    key: "addressCaption",
    caption: "Адрес места регистрации",
    needInForm: true,
  },
  docsDataCaption: {
    key: "docsDataCaption",
    caption: "Паспортные данные",
    needInForm: true,
  },
  address: {
    key: "address",
    label: "Адрес",
    type: "text",
    needInForm: true,
    placeholder: "Введите",
    cssKey: "address",
    textarea: true,
    required: true,
    upperCase: true,
  },
  addressEn: {
    key: "addressEn",
    label: "Address",
    type: "text",
    needInForm: true,
    placeholder: "Введите",
    cssKey: "address",
    textarea: true,
    required: true,
    pattern: {
      value: /^[a-zA-Z0-9\s.,;:!?'"()-]*$/,
      message: `Заполнение на английском языке`,
    },
    upperCase: true,
  },
  docTypeId: {
    key: "docTypeId",
    label: "Документ",
    type: "selectWithSearch",
    needInForm: true,
    placeholder: "Выберите",
    options: [],
    cssKey: "docs",
    required: true,
  },
  docSeries: {
    key: "docSeries",
    label: "Серия",
    type: "text",
    needInForm: true,
    placeholder: "Введите",
    cssKey: "docs",
    required: true,
    upperCase: true,
    pattern: {
      value: /^[a-zA-Z]{2}$/,
      message: `Введите 2 латинские буквы`,
    },
  },
  docNum: {
    key: "docNum",
    label: "Номер",
    type: "text",
    needInForm: true,
    placeholder: "Введите",
    cssKey: "docs",
    required: true,
    maxLength: 7,
    pattern: {
      value: /^[0-9]+[0-9]*$/,
      message: `Введите только цифры`,
    },
  },
  docDateIssue: {
    key: "docDateIssue",
    label: "Дата выдачи",
    type: "date",
    needInForm: true,
    placeholder: "Введите",
    cssKey: "docs",
    required: true,
    customValidation(value) {
      if (new Date(value) > new Date()) {
        return "Дата не может быть позднее текущей";
      } else if (new Date(value) < new Date("1996-09-26T00:00:00.000+03:00")) {
        return "Дата не может быть ранее 26.09.1996";
      } else {
        return true;
      }
    },
  },
  docDepartment: {
    key: "docDepartment",
    label: "Кем выдан",
    type: "text",
    needInForm: true,
    placeholder: "Введите",
    cssKey: "docs",
    required: true,
    upperCase: true,
  },
  persNum: {
    key: "persNum",
    label: "Идентификационный номер",
    type: "text",
    needInForm: true,
    placeholder: "Введите",
    cssKey: "docs",
    required: true,
    upperCase: true,
    pattern: {
      value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
      message: `Введите номер в формате "0000000A000AA0"`,
    },
  },
};

export const setupOptionsAddressCertificateByCertificateType = (typeId) => {
  if (typeId) {
    if (Number(typeId) === 1) {
      for (let item in fieldsAddressDocCertificate) {
        if (fieldsAddressDocCertificate[item].key.includes("En")) {
          fieldsAddressDocCertificate[item].needInForm = false;
        }
      }
    } else {
      for (let item in fieldsAddressDocCertificate) {
        if (fieldsAddressDocCertificate[item].key.includes("En")) {
          fieldsAddressDocCertificate[item].needInForm = true;
        }
      }
    }
    return fieldsAddressDocCertificate;
  }
};

export function setDocOptionsDocumentsFromDictionaries(docLib) {
  if (docLib.length > 0) {
    const validLibInterested = docLib.map((item) => {
      return {
        ...item,
        key: "docTypeId",
      };
    });
    if (fieldsAddressDocCertificate.docTypeId.options.length === 0) {
      fieldsAddressDocCertificate.docTypeId.options.push(...validLibInterested);
    }
  }
}
